import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Card from '../elements/Card';
import { getFpactList, getLocationsList } from '../../actions/locationActions.js';

@connect((store) => {
    return { 
        title: store.meta.pharmacyListingTitle,
        pharmacies: store.location.filteredList,
        isFpact: store.user.isFpactHolder
    };
})
class PharmacyListing extends React.Component {

    constructor(props) {
        super(props);
        this.goToClinicDetails = this.goToClinicDetails.bind(this);
    }

    componentWillMount() {
        if (this.props.isFpact) {
            this.props.dispatch(getFpactList('true'));
        } else {
            this.props.dispatch(getLocationsList('pharmacy'));
        }
    }

    // componentWillUnmount() {
    //     document.getElementById('root').style.display = 'flex';
    // }

    // componentWillReceiveProps() {
    //     document.getElementById('root').style.display = 'block';
    // }

    goToClinicDetails (clinicId) {
        let url = '/location?id=' + clinicId;
        this.props.history.push(url);
    }
    
    render() {

        let pharmacyList = [];

        for (let pharmacy in this.props.pharmacies) {
            let title = this.props.pharmacies[pharmacy].displayName;
            let price = this.props.pharmacies[pharmacy].price;

            pharmacyList.push(
                <Card key={pharmacy} 
                    history={this.props.history}
                    title={title} price={price}
                    link={pharmacy} />
             );
        }

        return (
            <div>
                <h1 className="ec__font__title text-center">{this.props.title}</h1>
                <div className="card-container">
                    {pharmacyList}
                </div>
            </div>
        )
    }
}

export default PharmacyListing;


// WEBPACK FOOTER //
// ./src/components/screens/PharmacyListing.js